import { DamageSide } from "./enums";

// Rows and columns each side of the vehicle is divided into on the damage
// diagrams. Front and rear are 2x2, the long sides are 2x4.
export const DamageGridShape = {
  [DamageSide.Front]: { rows: 2, columns: 2 },
  [DamageSide.Rear]: { rows: 2, columns: 2 },
  [DamageSide.DriverSide]: { rows: 2, columns: 4 },
  [DamageSide.PassengerSide]: { rows: 2, columns: 4 },
};

// { side: { row: { column: [] } } } with an empty bucket for every section
export function emptyDamageGrid() {
  const grid = {};

  for (const [side, { rows, columns }] of Object.entries(DamageGridShape)) {
    grid[side] = {};

    for (let row = 0; row < rows; row++) {
      grid[side][row] = {};

      for (let column = 0; column < columns; column++) {
        grid[side][row][column] = [];
      }
    }
  }

  return grid;
}

// Walks every section of the grid, handing each one to the callback
export function forEachDamageSection(callback) {
  for (const [side, { rows, columns }] of Object.entries(DamageGridShape)) {
    for (let row = 0; row < rows; row++) {
      for (let column = 0; column < columns; column++) {
        callback(Number(side), row, column);
      }
    }
  }
}
